import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from 'axios'
import Snack from './components/Snack.vue'
import VueI18n from "vue-i18n";
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import './assets/styles/vuetifyCustomstyle.css';
import Echo from "laravel-echo";
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';


import DefaultLayout from './layouts/DefaultLayout.vue'
import SellerLayout from './layouts/SellerLayout.vue'

Vue.component('default-layout', DefaultLayout)
Vue.component('seller-layout', SellerLayout)

/* eslint-disable */
// @ts-ignore
import translations from "./translations.js";
// @ts-ignore
import EventBus from "./EventBus.js"
require("./assets/zoom/bootstrap.css"); // bootstrap 3
require("./assets/zoom/react.css");
/* eslint-enable */
Vue.config.productionTip = false;
Vue.prototype.$http = axios
Vue.prototype.$bus = EventBus

// if (localStorage.locale == "ar") {
//   require("./assets/styles/rtl.css");
// } else if (localStorage.locale == "en") {
//   require("./assets/styles/ltr.css");
// }
import vuetify from "./plugins/vuetify";
// global component
Vue.component('Snack', Snack)
// global mixins
import { mapGetters } from "vuex";
Vue.mixin({
  data() {
    return {
      locale: localStorage.locale,
      defaultAvaterMale: require("./assets/images/default-avater-male.jpg"),
      defaultAvaterfeMale: require("./assets/images/default-avater-female.jpg")
    };
  },
  computed: {
    ...mapGetters(["getApiUrl", "getSocketUrl"])
  },
  watch: {},
  methods: {
    array_diff(array1, array2){
    /* eslint-disable */
    // @ts-ignore
      return array1.filter(x => !array2.includes(x)).concat(array2.filter(x => !array1.includes(x)));
    /* eslint-enable */
    }
  },
  mounted() {
    // window.scrollTo(0, 0);
  }
});

Vue.use(VueI18n);
// Vue.use(VueAwesomeSwiper);

export const i18n = new VueI18n({
  locale: localStorage.locale === "ar" ? "ar" : "en",
  fallbackLocale: "ar",
  messages: translations
});


if (window.location.protocol == "https:") {
  const socketUrl = store.getters.getSocketUrl;
  /* eslint-disable */
  const Pusher = require("pusher-js");
  Vue.prototype.$socket = new Echo({
    broadcaster: "pusher",
    key: "JawabAppKey",
    cluster: "mt1",
    wsHost: socketUrl,
    wsPort: 6001,
    wssPort: 6001,
    disableStats: true,
    enabledTransports: ["ws", "wss"],
    forceTLS: true
  });
}

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount("#app");


// axios.interceptors.response.use(
//   function (response) {
//     return response;
//   },
//   function (error) {
//     if (error.response.status === 401) {
//       const currentLocale = localStorage.locale;
//       localStorage.clear();
//       localStorage.locale = currentLocale;
//       window.location.href = '/'
//     }
//   }
// );

axios.interceptors.request.use(function (config) {
  config.headers.locale = localStorage.locale;

  return config;
});
